/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createBlog = /* GraphQL */ `
  mutation CreateBlog(
    $input: CreateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    createBlog(input: $input, condition: $condition) {
      id
      name
      posts {
        items {
          id
          title
          content
          visibility
          publishAt
          featuredImage
          featuredImageAlt
          exerpt
          author
          avatar
          categories
          tags
          seoTitle
          seoDescription
          handle
          duration
          media
          createdAt
          updatedAt
          blogPostsId
        }
        nextToken
      }
      image
      createdAt
      updatedAt
    }
  }
`;
export const updateBlog = /* GraphQL */ `
  mutation UpdateBlog(
    $input: UpdateBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    updateBlog(input: $input, condition: $condition) {
      id
      name
      posts {
        items {
          id
          title
          content
          visibility
          publishAt
          featuredImage
          featuredImageAlt
          exerpt
          author
          avatar
          categories
          tags
          seoTitle
          seoDescription
          handle
          duration
          media
          createdAt
          updatedAt
          blogPostsId
        }
        nextToken
      }
      image
      createdAt
      updatedAt
    }
  }
`;
export const deleteBlog = /* GraphQL */ `
  mutation DeleteBlog(
    $input: DeleteBlogInput!
    $condition: ModelBlogConditionInput
  ) {
    deleteBlog(input: $input, condition: $condition) {
      id
      name
      posts {
        items {
          id
          title
          content
          visibility
          publishAt
          featuredImage
          featuredImageAlt
          exerpt
          author
          avatar
          categories
          tags
          seoTitle
          seoDescription
          handle
          duration
          media
          createdAt
          updatedAt
          blogPostsId
        }
        nextToken
      }
      image
      createdAt
      updatedAt
    }
  }
`;
export const createPost = /* GraphQL */ `
  mutation CreatePost(
    $input: CreatePostInput!
    $condition: ModelPostConditionInput
  ) {
    createPost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        posts {
          nextToken
        }
        image
        createdAt
        updatedAt
      }
      comments {
        items {
          id
          content
          createdAt
          updatedAt
          postCommentsId
        }
        nextToken
      }
      content
      visibility
      publishAt
      featuredImage
      featuredImageAlt
      exerpt
      author
      avatar
      categories
      tags
      seoTitle
      seoDescription
      handle
      duration
      media
      faq {
        id
        question
        answer
      }
      createdAt
      updatedAt
      blogPostsId
    }
  }
`;
export const updatePost = /* GraphQL */ `
  mutation UpdatePost(
    $input: UpdatePostInput!
    $condition: ModelPostConditionInput
  ) {
    updatePost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        posts {
          nextToken
        }
        image
        createdAt
        updatedAt
      }
      comments {
        items {
          id
          content
          createdAt
          updatedAt
          postCommentsId
        }
        nextToken
      }
      content
      visibility
      publishAt
      featuredImage
      featuredImageAlt
      exerpt
      author
      avatar
      categories
      tags
      seoTitle
      seoDescription
      handle
      duration
      media
      faq {
        id
        question
        answer
      }
      createdAt
      updatedAt
      blogPostsId
    }
  }
`;
export const deletePost = /* GraphQL */ `
  mutation DeletePost(
    $input: DeletePostInput!
    $condition: ModelPostConditionInput
  ) {
    deletePost(input: $input, condition: $condition) {
      id
      title
      blog {
        id
        name
        posts {
          nextToken
        }
        image
        createdAt
        updatedAt
      }
      comments {
        items {
          id
          content
          createdAt
          updatedAt
          postCommentsId
        }
        nextToken
      }
      content
      visibility
      publishAt
      featuredImage
      featuredImageAlt
      exerpt
      author
      avatar
      categories
      tags
      seoTitle
      seoDescription
      handle
      duration
      media
      faq {
        id
        question
        answer
      }
      createdAt
      updatedAt
      blogPostsId
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blog {
          id
          name
          image
          createdAt
          updatedAt
        }
        comments {
          nextToken
        }
        content
        visibility
        publishAt
        featuredImage
        featuredImageAlt
        exerpt
        author
        avatar
        categories
        tags
        seoTitle
        seoDescription
        handle
        duration
        media
        faq {
          id
          question
          answer
        }
        createdAt
        updatedAt
        blogPostsId
      }
      content
      createdAt
      updatedAt
      postCommentsId
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blog {
          id
          name
          image
          createdAt
          updatedAt
        }
        comments {
          nextToken
        }
        content
        visibility
        publishAt
        featuredImage
        featuredImageAlt
        exerpt
        author
        avatar
        categories
        tags
        seoTitle
        seoDescription
        handle
        duration
        media
        faq {
          id
          question
          answer
        }
        createdAt
        updatedAt
        blogPostsId
      }
      content
      createdAt
      updatedAt
      postCommentsId
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      post {
        id
        title
        blog {
          id
          name
          image
          createdAt
          updatedAt
        }
        comments {
          nextToken
        }
        content
        visibility
        publishAt
        featuredImage
        featuredImageAlt
        exerpt
        author
        avatar
        categories
        tags
        seoTitle
        seoDescription
        handle
        duration
        media
        faq {
          id
          question
          answer
        }
        createdAt
        updatedAt
        blogPostsId
      }
      content
      createdAt
      updatedAt
      postCommentsId
    }
  }
`;
